import { useNavigate } from "react-router-dom";
import { ChevronLeft, LogOut } from "lucide-react";
import { BleReaderButton } from "@/components/BleReaderButton";

/**
 * Shared chrome for PDA pages. Big back button + page title + optional logout.
 * Tuned for ~480-720px PDA screens — chunky tap targets, no horizontal scroll.
 */
export default function PdaLayout({ title, subtitle, onBack, onLogout, children, footer }) {
  const navigate = useNavigate();
  const back = onBack || (() => navigate(-1));

  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col" data-testid="pda-layout">
      <header className="bg-neutral-900 text-white px-3 py-2 flex items-center gap-2 sticky top-0 z-20">
        <button
          onClick={back}
          className="h-11 w-11 -ml-2 flex items-center justify-center rounded-md hover:bg-neutral-800 active:bg-neutral-700"
          data-testid="pda-back"
          aria-label="Back"
        >
          <ChevronLeft className="h-7 w-7" />
        </button>
        <div className="flex-1 min-w-0">
          <div className="font-display font-bold text-lg leading-tight truncate">{title}</div>
          {subtitle ? <div className="text-[11px] text-neutral-400 truncate">{subtitle}</div> : null}
        </div>
        <BleReaderButton />
        {onLogout ? (
          <button
            onClick={() => { onLogout?.(); navigate("/pda/login", { replace: true }); }}
            className="h-11 w-11 flex items-center justify-center rounded-md hover:bg-neutral-800 active:bg-neutral-700"
            data-testid="pda-logout"
            aria-label="Logout"
          >
            <LogOut className="h-5 w-5" />
          </button>
        ) : null}
      </header>

      <main className="flex-1 px-3 py-3 overflow-y-auto">{children}</main>

      {footer ? (
        <footer className="border-t bg-white px-3 py-2 sticky bottom-0 z-10">{footer}</footer>
      ) : null}
    </div>
  );
}
